var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.995117 12.005C0.995117 5.92987 5.91998 1.005 11.9951 1.005C18.0702 1.005 22.9951 5.92987 22.9951 12.005C22.9951 18.0801 18.0702 23.005 11.9951 23.005C5.91998 23.005 0.995117 18.0801 0.995117 12.005ZM11.9951 3.005C7.02455 3.005 2.99512 7.03444 2.99512 12.005C2.99512 16.9756 7.02455 21.005 11.9951 21.005C16.9657 21.005 20.9951 16.9756 20.9951 12.005C20.9951 7.03444 16.9657 3.005 11.9951 3.005Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99512 12.005C4.99512 11.4527 5.44283 11.005 5.99512 11.005H17.9951C18.5474 11.005 18.9951 11.4527 18.9951 12.005C18.9951 12.5573 18.5474 13.005 17.9951 13.005H5.99512C5.44283 13.005 4.99512 12.5573 4.99512 12.005Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus_icon.f2a285f0.svg";
export { ForwardRef as ReactComponent };